import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from './modules/sidebar'
import layout from './modules/layout'
import auth from './modules/auth'
import competitorsCoverageModule from './modules/competitorscoverage'
import priceAlternationsModule from './modules/pricealternations'
import fastMovingProductsModule from './modules/fastmoving'
import livePriceLogModule from './modules/livepricelog'
import availabilityMappingModule from './modules/availabilityMapping'
import alertsModule from './modules/alerts'
import usersModule from './modules/users'
import productViewModule from './modules/productview'
import reportSettingsModule from './modules/reportSettings'
import userModule from './modules/user'
import analyticsCompetitorsCoverageModule from './modules/analytics/competitorscoverage'
import analyticsAverageDeviationModule from './modules/analytics/averageDeviation'
import analyticsSellersRankingModule from './modules/analytics/sellersRanking'
import analyticsSellersCategoryDistributionModule from './modules/analytics/sellersCategoryDistribution'
import analyticsSellersBrandDistributionModule from './modules/analytics/sellersBrandDistribution'
import analyticsFilterSellerModule from './modules/analytics/filterSeller'
import analyticsProfitOpportunitiesModule from './modules/analytics/profitOpportunities'
import analyticsPriceDistributionModule from './modules/analytics/priceDistribution'
import profileSettingsModule from './modules/profileSettings'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    sidebar,
    layout,
    auth,
    competitorsCoverageModule,
    priceAlternationsModule,
    fastMovingProductsModule,
    livePriceLogModule,
    availabilityMappingModule,
    alertsModule,
    usersModule,
    productViewModule,
    reportSettingsModule,
    userModule,
    analyticsCompetitorsCoverageModule,
    analyticsAverageDeviationModule,
    analyticsSellersRankingModule,
    analyticsSellersCategoryDistributionModule,
    analyticsSellersBrandDistributionModule,
    analyticsFilterSellerModule,
    analyticsProfitOpportunitiesModule,
    analyticsPriceDistributionModule,
    profileSettingsModule
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js